import COM_API from '@/api/masterData/company.js';
import { yesNoList } from '@/constants';
export const baseSearchColumns = (ctx) => {
  return [
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: ctx.contDisabled,
      placeholder: '请输入合同编号',
    },
    {
      prop: 'contractDetailCategory',
      name: '合同类型',
      type: 'dict',
      dictType: 'sales_contract_detail_category',
      placeholder: '请选择制单类型',
      changeMethod: 'changeContract',
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      placeholder: '请输入合同名称',
    },
    //客户名称4
    {
      prop: 'customer',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
        departmentCode: ctx.query.contractBusinessDepartment,
        companyCode: ctx.query.contractBusinessCompanyNo, //公司
      },
      isMultiple: true,
    },
    //项目编号5 fixme
    // {
    //   prop: 'projectInitiationNo',
    //   name: '项目编号',
    //   type: 'searchTableSpec',
    //   searchType: 'projectInitiation',
    //   placeholder: '请输入项目编号',
    //   isNeedMultipleValue: false,
    //   isMultiple: true,
    //   extraData: {
    //     projectInitiationStatusList: ['PIS04', 'PIS05'],
    //   },
    //   changeMethod: 'changeProject',
    // },
    {
      prop: 'projectName',
      name: '项目简称',
      searchType: 'projectInitiation',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.query?.projectName ? ctx.query?.projectName : null,
      checkRowKeys: [ctx.query.projectInitiationNo ? ctx.query.projectInitiationNo : null],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        // applyCompanyNo: ctx.query.companyCode,
        // applyDepartmentNo: ctx.query.contractBusinessDepartment,
        // platformtCompany: ctx.query.companyCode,
        // recyclingtCompany: ctx.query.companyCode,
        // applyDepartmentName: ctx.query.contractBusinessDepartmentName,

        // applyCompanyName: ctx.userInfo.userInfo.companyName,
        // platformtCompanyName: ctx.userInfo.userInfo.companyName,
        // recyclingtCompanyName: ctx.userInfo.userInfo.companyName,
      },
      changeMethod: 'changeProject',
    },
    //业务部门7
    {
      prop: 'contractBusinessDepartment',
      name: '业务部门',
      type: 'treeSelect',
      apiUrl: COM_API.LIST_COMPANY_API,
      apiData: {
        tenantCode: ctx.userInfo.userInfo.tenantCode,
        adminFlag: ctx.userInfo.userInfo.adminFlag,
      },
      multiple: true,
      clearable: false,
    },
    //负责人8   fixme
    // {
    //   prop: 'personChargeCode',
    //   type: 'searchTableSpec',
    //   name: '负责人',
    //   searchType: 'personnel',
    //   isNeedMultipleValue: false,
    //   isMultiple: false,
    // },
    // 合同签署日期9 合同生效日期10 合同到期日期11 fixme
    // {
    //   prop: 'signDateStart',
    //   name: '合同签署日期',
    //   type: 'startDaterangePicker',
    // },
    // {
    //   prop: 'signDateEnd',
    //   name: '合同签署日期至',
    //   type: 'endDaterangePicker',
    // },
    // {
    //   prop: 'contractValidStartBegin',
    //   name: '合同生效日期从',
    //   type: 'startDaterangePicker',
    // },
    // {
    //   prop: 'contractValidStartFinish',
    //   name: '合同生效日期至',
    //   type: 'endDaterangePicker',
    // },
    // {
    //   prop: 'contractValidEndBegin',
    //   name: '合同到期日期从',
    //   type: 'startDaterangePicker',
    // },
    // {
    //   prop: 'contractValidEndFinish',
    //   name: '合同到期日期至',
    //   type: 'endDaterangePicker',
    // },
    // {
    //   prop: 'performanceBondPayMethodCode',
    //   name: '履约保证金缴纳方式',
    //   type: 'select',
    //   options: ctx.dictListMap.performance,
    //   placeholder: '请选择履约保证金缴纳方式',
    // },
    // {
    //   prop: 'receiptMethod',
    //   name: '收款方式',
    //   type: 'select',
    //   placeholder: '请选择收款方式',
    //   options: ctx.dictListMap?.receipt_method,
    // },
    // {
    //   prop: 'recyclingCompanyFileNo',
    //   name: '回收公司档案编号',
    //   type: 'input',
    //   placeholder: '请输入回收公司档案编号',
    // },
    // {
    //   prop: 'recyclingCompanyName',
    //   name: '回收公司',
    //   type: 'input',
    //   placeholder: '请输入回收公司',
    // },
    // {
    //   prop: 'platformCompanyFileNo',
    //   name: '平台公司档案编号',
    //   type: 'input',
    //   placeholder: '请输入平台公司档案编号',
    // },
    // {
    //   prop: 'platformCompanyName',
    //   name: '平台公司',
    //   type: 'input',
    //   placeholder: '请输入平台公司',
    // },
    // {
    //   prop: 'pricingRule',
    //   name: '定价模式',
    //   type: 'dict',
    //   clearable: true,
    //   dictType: 'pricing_rule',
    //   placeholder: '请选择定价规则',
    // },
    {
      name: '合同标的',
      prop: 'contractMatter',
      type: 'searchTableSpec',
      searchType: 'product',
      isNeedMultipleValue: true,
      isMultiple: true,
      extraData: {
        detailProductStatus: 'ZT03',
        contractCategory: 'sales',
        adminFlag: 2,
      },
      changeMethod: 'changeContractMatter',
    },
    // {
    //   type: 'input',
    //   prop: 'amountStart',
    //   name: '合同总金额从',
    // },
    // {
    //   type: 'input',
    //   prop: 'amountEnd',
    //   name: '合同总金额到',
    // },
    {
      prop: 'contractStatus',
      name: '单据状态',
      type: 'dict',
      dictType: 'contract_status',
      placeholder: '请选择单据状态',
    },
    // {
    //   prop: 'materialType',
    //   name: '料型',
    //   type: 'select',
    //   placeholder: '请输入料型',
    //   options: ctx.dictListMap.materialType,
    // },
    // {
    //   type: 'input',
    //   prop: 'priceStart',
    //   name: '合同含税单价从',
    // },
    // {
    //   type: 'input',
    //   prop: 'priceEnd',
    //   name: '合同含税单价到',
    // },
    // {
    //   type: 'input',
    //   prop: 'quantityStart',
    //   name: '销售数量从',
    // },
    // {
    //   type: 'input',
    //   prop: 'quantityEnd',
    //   name: '销售数量到',
    // },
    // {
    //   type: 'date',
    //   prop: 'contractCreateStartDate',
    //   format: 'yyyy-MM-dd',
    //   name: '制单日期从',
    // },
    // {
    //   type: 'date',
    //   prop: 'contractCreateEndDate',
    //   format: 'yyyy-MM-dd',
    //   name: '制单日期至',
    // },
    // {
    //   prop: 'contractOperaterNo',
    //   type: 'searchTableSpec',
    //   name: '操作人',
    //   searchType: 'personnel',
    //   isNeedMultipleValue: true,
    // },
    // {
    //   prop: 'externalContractNo',
    //   name: '外部合同号',
    //   type: 'input',
    //   placeholder: '请输入外部合同号',
    // },

    {
      prop: 'isFixedPrice',
      name: '不定价',
      type: 'select',
      placeholder: '请选择不定价',
      options: yesNoList,
    },
    // {
    //   prop: 'settlementDate',
    //   name: '结算日',
    //   type: 'dict',
    //   dictType: 'settlementDate',
    // },
    // {
    //   prop: 'incomeMethod',
    //   name: '收益方式',
    //   type: 'dict',
    //   dictType: 'incomeMethod',
    //   placeholder: '请选择收益方式',
    // },

    // {
    //   prop: 'isDefault',
    //   name: '是否有违约责任',
    //   type: 'checkbox',
    // },
    // {
    //   prop: 'overduePeriodStart',
    //   name: '逾期周期从',
    //   type: 'startDaterangePicker',
    // },
    // {
    //   prop: 'overduePeriodEnd',
    //   name: '逾期周期到',
    //   type: 'endDaterangePicker',
    // },
    // {
    //   type: 'dict',
    //   dictType: 'liquidatedDamages',
    //   name: '合同违约金类型',
    //   prop: 'liquidatedDamagesType',
    // },
    // {
    //   type: 'input',
    //   prop: 'liquidatedFixedValueStart',
    //   name: '违约金固定值从',
    // },
    // {
    //   type: 'input',
    //   prop: 'liquidatedFixedValueEnd',
    //   name: '违约金固定值到',
    // },
    // {
    //   type: 'input',
    //   prop: 'liquidatedInterestRateStart',
    //   name: '违约金日利率从',
    // },
    // {
    //   type: 'input',
    //   prop: 'liquidatedInterestRateStartEnd',
    //   name: '违约金日利率到',
    // },

    // {
    //   type: 'dict',
    //   dictType: 'qualityGuaranteeDepositMethod',
    //   name: '质保金收取方式',
    //   prop: 'qualityGuaranteeDepositMethodCode',
    // },
    // {
    //   type: 'input',
    //   prop: 'chargeFixedValueStart',
    //   name: '收取固定值从',
    // },
    // {
    //   type: 'input',
    //   prop: 'chargeFixedValueEnd',
    //   name: '收取固定值到',
    // },
    // {
    //   type: 'input',
    //   prop: 'chargeProportionEnd',
    //   name: '收取比例从',
    // },
    // {
    //   type: 'input',
    //   prop: 'chargeProportionEnd',
    //   name: '收取比例到',
    // },
    // {
    //   type: 'date',
    //   format: 'yyyy-MM-dd',
    //   prop: 'qualityGuaranteeDepositOverdueStart',
    //   name: '质保金逾期期限从',
    // },
    // {
    //   type: 'date',
    //   format: 'yyyy-MM-dd',
    //   prop: 'qualityGuaranteeDepositOverdueEnd',
    //   name: '质保金逾期期限到',
    // },
    // {
    //   type: 'input',
    //   prop: 'marginAmountStart',
    //   name: '保证金从',
    // },
    // {
    //   type: 'input',
    //   prop: 'marginAmountEnd',
    //   name: '保证金到',
    // },
    {
      prop: 'isPersonalPartner',
      name: '是否个人合作伙伴',
      type: 'select',
      placeholder: '请选择是否个人合作伙伴',
      options: yesNoList,
    },
  ];
};

// 表格列
export const baseColumnListDefault = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'contractDetailCategoryName',
    title: '合同类型',
    visible: true,
  },
  {
    field: 'contractName',
    title: '合同名称',
    visible: true,
  },
  {
    field: 'contractStatusName',
    title: '单据状态',
    visible: true,
  },
  {
    field: 'oaUrl',
    title: '审批详情',
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },
  {
    field: 'projectInitiationNo',
    title: '项目编号',
    visible: true,
  },
  {
    field: 'projectName',
    title: '项目简称',
    visible: true,
  },
  {
    field: 'contractBusinessDepartmentName',
    title: '业务部门',
    visible: true,
  },
  {
    field: 'personChargeName',
    title: '负责人',
    visible: true,
  },
  {
    field: 'signDate',
    title: '合同签署日期',
    visible: true,
  },
  {
    field: 'contractValidEnd',
    title: '合同到期日期',
    visible: true,
  },
  {
    //fixme保存的时候没有传
    field: 'performanceBondPayMethodName',
    title: '履约保证金缴纳方式',
    visible: true,
  },
  {
    field: 'recyclingCompanyFileNo',
    title: '回收公司档案编号',
    visible: true,
  },
  {
    field: 'recyclingCompanyName',
    title: '回收公司',
    visible: true,
  },
  {
    field: 'platformCompanyFileNo',
    title: '平台公司档案编号',
    visible: true,
  },
  {
    field: 'platformCompanyName',
    title: '平台公司',
    visible: true,
  },
  {
    field: 'pricingRuleName',
    title: '定价模式',
    visible: true,
  },
  {
    field: 'contractMatterName',
    title: '合同标的',
    visible: true,
  },
  {
    field: 'contractTotalAmount',
    title: '合同总金额',
    visible: true,
  },
  {
    field: 'materialTypeName',
    title: '料型',
    visible: true,
  },
  {
    field: 'businessContractUnitPrice',
    title: '合同含税单价',
    visible: true,
  },
  {
    field: 'contractCreateDate',
    title: '制单日期',
    visible: true,
  },
  //fixme保存的时候需要带出
  {
    field: 'contractOperaterName',
    title: '操作人',
    visible: true,
  },
  {
    field: 'companyName',
    title: '公司',
    visible: true,
  },
  {
    field: 'externalContractNo',
    title: '外部合同号',
    visible: true,
  },
  {
    field: 'isFixedPrice',
    title: '不定价',
    visible: true,
  },
  //物贸
  {
    field: 'settlementDate',
    title: '结算日',
    visible: true,
  },
  //物贸
  {
    field: 'incomeMethod',
    title: '收益方式',
    visible: true,
  },
  //物贸
  {
    field: 'isDefault',
    title: '是否有违约责任',
    visible: true,
  },
  //物贸
  {
    field: 'overduePeriod',
    title: '逾期周期',
    visible: true,
  },
  //物贸
  {
    field: 'liquidatedDamagesType',
    title: '合同违约金类型',
    visible: true,
  },
  //物贸
  {
    field: 'liquidatedFixedValue',
    title: '违约金固定值',
    visible: true,
  },
  //物贸
  {
    field: 'liquidatedInterestRate',
    title: '违约金日利率',
    visible: true,
  },
  //物贸
  {
    field: 'qualityGuaranteeDepositMethodCode',
    title: '质保金收取方式',
    visible: true,
  },
  //物贸
  {
    field: 'chargeProportion',
    title: '收取固定值',
    visible: true,
  },
  //物贸
  {
    field: 'chargeProportion',
    title: '收取比例',
    visible: true,
  },
  //物贸
  {
    field: 'qualityGuaranteeDepositOverdue',
    title: '质保金逾期期限',
    visible: true,
  },
  //物贸
  {
    field: 'marginAmount',
    title: '保证金',
    visible: true,
  },
];
